import { Component, OnInit,ViewChild  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DynamicPageComponent } from '../../helpers/dynamicPage';
import { DynamicPageDirective } from '../../directives/index';
import { DynamicPage,User} from '../../models/data.types';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ApiService } from '../../services/api.service';
import { Title } from '@angular/platform-browser';

@Component({
  moduleId: module.id,
  templateUrl: 'login.component.html',
  entryComponents: [DynamicPageComponent],
})
export class LoginComponent {
  @ViewChild(DynamicPageDirective) dynamicPage: DynamicPageDirective;

  title: string;
  
  constructor(private route: ActivatedRoute,
    private router: Router, 
    private apiService : ApiService,
    private titleService: Title) {  }

  ngOnInit() {

    let dynamicPageComponent = new DynamicPageComponent(this.route,this.apiService,this.titleService);
    dynamicPageComponent.LoadDynamicPage("AppShellLogin",this.dynamicPage,true).then(x => this.title = x);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/login/login.component.ts